<template>
  <section class="content">
    <div class="container">
      <div class="row">
        <div class="col-sm-12 contact-form card">
          <h3 class="text-5 p-0">
            Get in touch
          </h3>
          <h4 class="text-6 p-0 m-0">
            Let us know how we can help, <a href="mailto:hello@drops.nyc">hello@drops.nyc</a>
          </h4>
          <form
            id="contact"
            method="post"
            class="form card-body"
            role="form"
            @submit="submit()"
          >
            <div class="row">
              <div class="col-xs-12 col-md-12 form-group">
                <input
                  id="name"
                  v-model="contact.name"
                  class="form-control"
                  name="name"
                  placeholder="Your name"
                  type="text"
                  required
                  autofocus
                >
              </div>
              <div class="col-xs-12 col-md-12 form-group">
                <input
                  id="email"
                  v-model="contact.email"
                  class="form-control"
                  name="email"
                  placeholder="Your email"
                  type="email"
                  required
                >
              </div>
            </div>
            <textarea
              id="message"
              v-model="contact.message"
              class="form-control"
              name="message"
              placeholder="Message"
              rows="5"
            />
            <br>
            <button class="btn btn-block btn-secondary form-button" type="submit">
              Send message
            </button>
          </form>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  layout: 'empty',
  data () {
    return {
      contact: {
        name: '',
        email: '',
        message: ''
      }
    }
  },
  methods: {
    async submit (args) {
      try {
        if (this.contact.email === '') {
          this.$toast.error('missing email')
        } else {
          try {
            const response = await this.$axios.post('contactUs', this.contact)
            if (response.data.error) {
              this.$toast.error(response.data.error)
            } else {
              this.$toast.success(
                'sent! thanks for reaching out. We will get back to back to you shortly.'
              )
            }
          } catch (err) {
            this.$toast.error(err)
          }
        }
      } catch (error) {
        this.$toast.error(error)
      }
    }
  }
}
</script>

<!-- Begin Mailchimp Signup Form --
<link href="//cdn-images.mailchimp.com/embedcode/horizontal-slim-10_7.css" rel="stylesheet" type="text/css">
<style type="text/css">
	#mc_embed_signup{background:#fff; clear:left; font:14px Helvetica,Arial,sans-serif; width:100%;}
	/* Add your own Mailchimp form style overrides in your site stylesheet or in this style block.
	   We recommend moving this block and the preceding CSS link to the HEAD of your HTML file. */
</style>
<style type="text/css">
	#mc-embedded-subscribe-form input[type=checkbox]{display: inline; width: auto;margin-right: 10px;}
	#mergeRow-gdpr {margin-top: 20px;}
	#mergeRow-gdpr fieldset label {font-weight: normal;}
	#mc-embedded-subscribe-form .mc_fieldset{border:none;min-height: 0px;padding-bottom:0px;}
</style>
<div id="mc_embed_signup">
<form action="https://nyc.us2.list-manage.com/subscribe/post?u=9a9f1e52323f82d052187a0f0&amp;id=d53732570e" method="post" id="mc-embedded-subscribe-form" name="mc-embedded-subscribe-form" class="form validate" target="_blank" novalidate>
    <div id="mc_embed_signup_scroll" class="container-fluid">
		<div class="row">
			<label for="mce-EMAIL">Join our Beta Mailing list</label>
		</div>
	<div class="row">
	<input type="email" value="" name="EMAIL" class="email col m-1" id="mce-EMAIL" placeholder="email address" required>
    <!-- real people should not fill this in and expect good things - do not remove this or risk form bot signups--
    <div style="position: absolute; left: -5000px;" aria-hidden="true"><input type="text" name="b_9a9f1e52323f82d052187a0f0_d53732570e" tabindex="-1" value=""></div>
    <button class="btn p-0"><input type="submit" value="Join" name="subscribe" id="mc-embedded-subscribe" class="btn no-margin py-1 m-0"></button>
	</div>
</div>
</form>
</div>
-->
<!--End mc_embed_signup-->

<style scoped>
.font-awesome-icon {
  font-size: 24px;
}
.text-5 {
  font-family: Arial, sans-serif;
  color: #9990FF;
  text-align: center;
  font-size: 32px;
  font-weight: 700;
  line-height: 120%;
}
.text-6 {
  font-family: Arial, sans-serif;
  color: #D9D9D9;
  text-align: center;
  font-size: 16px;
  font-weight: 600;
  line-height: 150%;
}
.text-6 a{
  font-family: Arial, sans-serif;
  color: #9990FF;
  text-align: center;
  font-size: 16px;
  font-weight: 600;
  line-height: 150%;
}

.form-button {
  width: 100%;
  grid-column-gap: 8px;
  grid-row-gap: 8px;
  color: #fff;
  background-color: #9990FF;
  justify-content: center;
  align-items: center;
  padding: 12px 24px;
  font-size: 16px;
  font-weight: 600;
  line-height: 140%;
  display: flex;
}

.contact-form {
  width: 100%;
  grid-column-gap: 64px;
  background-color: #000000;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  display: flex;
}

.card-body {
  width: 100%;
}
</style>
